// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3782":"7815eed16283f58c","5922":"27d2e1e07552bde3"}[chunkId] + ".css";
};